import { ChangeDetectionStrategy, Component, Input, OnInit, booleanAttribute } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { Observable, map, startWith } from 'rxjs';

@Component({
  selector: 'app-required-input-wrapper',
  templateUrl: './required-input-wrapper.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RequiredInputWrapperComponent implements OnInit {
  @Input({ required: true }) control!: AbstractControl;
  @Input({ required: true }) label!: string;
  @Input({ required: true }) touched!: boolean;
  @Input({ transform: booleanAttribute }) isDisabled = false;

  protected hasValue$!: Observable<{ hasValue: boolean }>;

  ngOnInit() {
    if (!this.control) return;
    const control = this.control;
    this.hasValue$ = control.valueChanges.pipe(
      startWith(control.value),
      map(currentValue => ({ hasValue: !!currentValue }))
    );
  }
}
